<template>
  <div>
      <div class="grade_box">
          <div class="title">上周年级扣分表</div>
          <el-table border :data="tableData" :size="isMB?'mini':'medium'" stripe class="report_table">
            <el-table-column prop="Class" label="班级" align="center" fixed="left" min-width="90">
                <template slot-scope="{row}">
                    {{row.Grade + row.Class}}
                </template>
            </el-table-column>
            <el-table-column prop="StudentCount" label="人数" align="center" />
            <el-table-column prop="Point" label="总扣分" align="center" />
            <el-table-column prop="DisciplineTypeNameChain" label="扣分值最多类型" align="center" min-width="110"/>
            <el-table-column prop="New8FullNames" label="新增达8分学生" align="center" min-width="110" />
            <el-table-column prop="After6FullNames" label="处理后增达6分学生" align="center" min-width="125" />
          </el-table>
      </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      api: require("@/api/attendance/disrecord").default,
      tableData: [],
      day: "",
      isMB: this.$store.state.isMB,
    };
  },
  beforeMount() {
      var today = new Date();
      var day = today.getDay();
      var StartDate = this.$commonJs.toDateString(today.getTime() - (day+6) * 86400000);
      this.api.getGradeReport({ StartDate }).then(res => {
          if(res.Code==0) {
            this.tableData = res.Data;
            // this.tableData = [
            //     { Grade: "高一", Class: "01", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "02", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "03", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "04", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "05", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "06", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "07", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "08", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "09", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "10", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "11", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "12", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "13", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "14", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "15", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "16", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "17", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "18", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "19", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "20", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "21", StudentCount: 0, Point: 0 },
            //     { Grade: "高一", Class: "22", StudentCount: 0, Point: 0 },
            // ];
          } else {
            this.$message.error(res.Msg)
          }
      })
  },
};
</script>
<style lang="scss" scoped>
.grade_box {
    padding: 1.5% 4% 1.5%;
    .title {
        line-height: 40px;
        font-size: 16px;
    }
    .report_table {
        // /deep/ .el-table__body-wrapper {
        //     max-height: 80vh;
        //     overflow-y: auto;
        // }
        /deep/ .el-table__body-wrapper::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
            border-radius: 10px;
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
            background: rgba(0, 0, 0, 0.2);
        }

        /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            -webkit-box-shadow: inset 0 0 5px rgba(150, 150, 150, 0.2);
            border-radius: 0;
            background: rgba(0, 0, 0, 0.1);
        }
    }
}
</style>